export default __webpack_public_path__ + "static/media/lato-bold.a3e5f4a6.ttf";